import { render, staticRenderFns } from "./create-login-dialog-and-button.vue?vue&type=template&id=3f031a1e"
import script from "./create-login-dialog-and-button.vue?vue&type=script&lang=js"
export * from "./create-login-dialog-and-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports